<template>
  <v-container class="mt-10">
    <v-row justify="center">
      <v-col cols="10" sm="8" md="6" class="text-center">
        <h1 class="display-2 font-weight-bold mb-3 text-center"
          v-html="$t('pages.not-found.title')"/>
      </v-col>
    </v-row>

    <v-row justify="center" class="text-center">
      <v-col cols="10"  sm="8" md="6">
        <p v-html="$t('pages.not-found.description', { orgPath: orgPath })"/>
      </v-col>
    </v-row>
    
  </v-container>
</template>

<script>
import urlUtil from '@/js/utils/urlUtil';
export default {
  name: "error-page",
  metaInfo () {
    return {
      title: '404',
      meta: [
        { name: 'robots', content: 'noindex,follow' },
        { name: 'prerender-status-code', content: '404' }
      ]
    }
  },
  computed: {
    orgPath: function() {
      let organizationPath = urlUtil.getCurrentOrganizationPath();
      return organizationPath ?? "/"
    }
  },
}
</script>